import units from '@/sui/data/units'

const fieldInfos = [
  { n: 'totalBeds', s: 'TotalBeds' },
  { n: 'detailBeds', s: 'DetailBeds' },
  { n: 'detailSurveillance', s: 'DetailSurveillance' },
  { n: 'activeQueue', s: 'ActiveQueue' },
  { n: 'activeQueueSurveillance', s: 'ActiveQueueSurveillance' },
  { n: 'hospiDays', s: 'HospiDays' },
  { n: 'hospiDays2018', s: 'HospiDays2018' },
  { n: 'uf', s: 'Uf' },
  { n: 'watchedBeds', s: 'WatchedBeds' },
  { n: 'entrances', s: 'Entrances' },
  { n: 'dialysisCount', s: 'DialysisCount' }
]

const module = (function () {
  function build (y) {
    const uy = units[y]
    const result = {
      bedCount: 'bedCount'
    }

    fieldInfos.forEach(
      e => {
        result[e.n] = f => `${f}${e.s}`
      }
    )

    result.adTypes = [
      {
        field: 'adRea',
        tooltip: 'de réanimation',
        title: 'RÉANIMATION',
        index: uy.disc.adRea.index,
        list: uy.disc.adRea.list
      },
      {
        field: 'adMed',
        tooltip: 'de médecine',
        title: 'MÉDECINE',
        index: uy.disc.adMed.index,
        list: [
          ...uy.disc.adMed.list,
          ...uy.disc.adCan.list,
          ...uy.disc.adRad.list,
          ...uy.disc.adHem.list
        ],
        subfields: [
          {
            field: 'adMedCan',
            title: 'MÉDECINE CARCINOLOGIQUE / ONCOLOGIE',
            index: 2000,
            code: 'AD CAN',
            tooltip: 'de médecine carcinologique / oncologie'
          },
          {
            field: 'adMedRad',
            index: 2001,
            code: 'AD RAD',
            title: 'RADIOTHÉRAPIE / CURIETHÉRAPIE / MÉDECINE NUCLÉAIRE',
            tooltip: 'de radiothérapie / curiethérapie / médecine nucléaire'
          },
          {
            field: 'adMedHem',
            index: 2002,
            code: 'AD HEM',
            title: 'HÉMATOLOGIE',
            tooltip: `d'hématologie`
          }
        ]
      },
      {
        field: 'adUrg',
        tooltip: `d'urgences/service porte`,
        link: `D'`,
        index: uy.disc.adUrg.index,
        title: `URGENCES/SERVICE PORTE`,
        skipEntrances: true
      },
      {
        field: 'adChir',
        tooltip: 'de chirurgie',
        title: 'CHIRURGIE',
        index: uy.disc.adChir.index,
        list: uy.disc.adChir.list
      },
      {
        field: 'adObs',
        tooltip: 'de gynécologie/obstétrique',
        title: 'GYNÉCOLOGIE/OBSTÉTRIQUE',
        index: uy.disc.adObs.index,
        list: uy.disc.adObs.list
      },
      {
        field: 'adSSR',
        tooltip: 'de soins de suite et de réadaptation',
        title: 'SOINS DE SUITE ET DE RÉADAPTATION',
        index: uy.disc.adSSR.index,
        list: uy.disc.adSSR.list
      },
      {
        field: 'adPsy',
        tooltip: 'de psychiatrie',
        title: 'PSYCHIATRIE',
        index: uy.disc.adPsy.index
      },
      {
        field: 'adDia',
        tooltip: 'de dialyse',
        type: 'dia',
        title: 'DIALYSE',
        index: uy.disc.adDia.index,
        skipEntrances: true,
        list: uy.disc.adDia.list
      },
      {
        field: 'adHAD',
        tooltip: `d'hospitalisation à domicile`,
        link: `D'`,
        type: 'had',
        title: `HOSPITALISATION À DOMICILE`,
        index: uy.disc.adHAD.index
      },
      {
        field: 'adSLD',
        tooltip: 'de soins de longue durée',
        title: 'SOINS DE LONGUE DURÉE',
        index: uy.disc.adSLD.index
      },
      {
        field: 'adEHP',
        tooltip: 'EHPAD',
        link: '',
        title: 'EHPAD',
        index: uy.disc.adEHP.index
      }
    ]

    result.pedTypes = [
      {
        field: 'pedRea',
        tooltip: 'de réanimation pédiatrique',
        title: 'RÉANIMATION PÉDIATRIQUE',
        index: uy.disc.pedRea.index
      },
      {
        field: 'pedMed',
        tooltip: 'de médecine pédiatrique',
        title: 'MÉDECINE PÉDIATRIQUE',
        index: uy.disc.pedMed.index,
        list: [
          ...uy.disc.pedMed.list,
          ...uy.disc.pedCan.list
        ],
        subfields: [
          {
            field: 'pedMedCan',
            title: 'MÉDECINE CARCINOLOGIQUE / ONCOLOGIE PÉDIATRIQUE',
            tooltip: 'de médecine carcinologique / oncologie pédiatrique',
            index: 2100,
            code: 'PED MED CAN'
          }
        ]
      },
      {
        field: 'pedUrg',
        tooltip: `d'urgences/service porte`,
        link: `D'`,
        title: `URGENCES/SERVICE PORTE PÉDIATRIQUE`,
        index: uy.disc.pedUrg.index,
        skipEntrances: true
      },
      {
        field: 'pedChir',
        tooltip: 'de chirurgie pédiatrique',
        title: 'CHIRURGIE PÉDIATRIQUE',
        list: uy.disc.pedChir.list,
        index: uy.disc.pedChir.index
      },
      {
        field: 'pedSSR',
        tooltip: 'de soins de suite et de réadaptation pédiatrique',
        title: 'SOINS DE SUITE ET DE RÉADAPTATION PÉDIATRIQUE',
        index: uy.disc.pedSSR.index
      },
      {
        field: 'pedPsy',
        tooltip: 'de pédo-psychiatrie',
        title: 'PÉDO-PSYCHIATRIE',
        index: uy.disc.pedPsy.index
      },
      {
        field: 'pedDia',
        tooltip: 'de dialyse pédiatrique',
        type: 'dia',
        title: 'DIALYSE PÉDIATRIQUE',
        index: uy.disc.pedDia.index,
        skipEntrances: true
      },
      {
        field: 'pedHAD',
        tooltip: `d'hospitalisation à domicile pédiatrique`,
        link: `D'`,
        type: 'had',
        title: `HOSPITALISATION À DOMICILE PÉDIATRIQUE`,
        index: uy.disc.pedHAD.index
      },
      {
        field: 'pedSLD',
        tooltip: 'de soins de longue durée pédiatriques',
        title: 'SOINS DE LONGUE DURÉE PÉDIATRIQUES',
        index: uy.disc.pedSld.index
      }
    ]

    result.neoTypes = [
      {
        field: 'neoRea',
        tooltip: 'de réanimation néonatale',
        title: 'RÉANIMATION NÉONATALE',
        index: uy.disc.neoRea.index
      },
      {
        field: 'neoMed',
        tooltip: 'de médecine néonatale',
        title: 'MÉDECINE NÉONATALE',
        list: uy.disc.neoMed.list,
        index: uy.disc.neoMed.index
      },
      {
        field: 'neoUrg',
        tooltip: `d'urgences/service porte`,
        link: `D'`,
        title: `URGENCES/SERVICE PORTE NÉONATALE`,
        index: uy.disc.neoUrg.index,
        skipEntrances: true
      },
      {
        field: 'neoChir',
        tooltip: 'de chirurgie néonatale',
        title: 'CHIRURGIE NÉONATALE',
        list: uy.disc.neoChir.list,
        index: uy.disc.neoChir.index
      }
    ]

    result.mixTypes = [
      {
        field: 'mixRea',
        tooltip: 'de réanimation mixte',
        title: 'RÉANIMATION MIXTE',
        index: uy.disc.mixRea.index
      }
    ]

    result.allTypes = result.adTypes.concat(
      result.pedTypes, result.neoTypes, result.mixTypes
    )

    return result
  }

  return {
    '2019': build('2019'),
    '2020': build('2020'),
    '2021': build('2021'),
    '2022': build('2022'),
    '2023': build('2023'),
    '2024': build('2024'),
    '2025': build('2025'),
    '2026': build('2026')
  }
})()

export default module
